import { useCallback, useState } from "react";
import type { Slide } from "./slide.types";

export interface SlideDeck {
  slides: Slide[];
  currentIndex: number;
  goNext: () => void;
  goPrev: () => void;
  goTo: (index: number) => void;
}

function clamp(index: number, length: number): number {
  if (length === 0) return 0;
  if (index < 0) return 0;
  if (index > length - 1) return length - 1;
  return index;
}

export function useSlideDeck(slides: Slide[]): SlideDeck {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goNext = useCallback(() => {
    setCurrentIndex((i) => clamp(i + 1, slides.length));
  }, [slides.length]);

  const goPrev = useCallback(() => {
    setCurrentIndex((i) => clamp(i - 1, slides.length));
  }, [slides.length]);

  const goTo = useCallback(
    (index: number) => {
      setCurrentIndex(clamp(index, slides.length));
    },
    [slides.length],
  );

  return { slides, currentIndex, goNext, goPrev, goTo };
}
